<template>
	<div class="d-flex-between-center align-items-start p-d-8">
		<div class="d-block">
			<div>
				<span class="f-regular f-14 f-c-black">Tunai</span>
				<span class="f-regular f-14 f-c-midgrey">  •  {{ tipeBayar }}</span>
			</div>
			<div class="f-regular f-12 f-c-midgrey">
				{{ pembayaran.waktu_bayar }} oleh {{ pembayaran.nama_karyawan }}
			</div>
		</div>
		<div class="f-regular f-14 f-c-black">
			{{ formatRupiah(pembayaran.dibayar.toString()) }}
		</div>
	</div>
</template>

<script>
export default {
	name: "SOPembayaranTunai",
	props: {
		pembayaran: Object,
		tipeBayar: String,
	}
}
</script>